import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServiceDetail from './components/ServiceDetail';

export default function ServicesPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  const services = [
    {
      id: 'old-house',
      title: '舊屋改造',
      subtitle: '讓老屋重獲新生',
      description: '結構更新、格局優化、水電重整，讓舊屋安全舒適。我們專注於30年以上老屋的全面改造，從基礎結構到美學設計，打造安全、舒適、現代化的居住空間。',
      features: [
        { icon: 'ri-building-line', text: '結構安全評估與補強' },
        { icon: 'ri-layout-grid-line', text: '格局重新規劃優化' },
        { icon: 'ri-flashlight-line', text: '水電管線全面更新' },
        { icon: 'ri-paint-brush-line', text: '牆面地板翻新處理' },
        { icon: 'ri-window-line', text: '門窗更新與氣密效果' },
        { icon: 'ri-shield-check-line', text: '防水工程重新施作' },
      ],
      image: 'https://public.readdy.ai/ai/img_res/0aa8f6ca054cb74977c161dfc774f036.jpg',
      benefits: [
        '提升居住安全性',
        '改善生活品質',
        '增加房屋價值',
        '延長建築壽命',
      ],
    },
    {
      id: 'bathroom',
      title: '浴室改造',
      subtitle: '打造飯店級衛浴空間',
      description: '打除重作、防水更新、設備換新，提升生活品質與房屋價值。專業的防水工程與現代化設備，讓您的浴室煥然一新。',
      features: [
        { icon: 'ri-hammer-line', text: '舊浴室完整打除' },
        { icon: 'ri-drop-line', text: '防水層重新施作' },
        { icon: 'ri-grid-line', text: '磁磚更新' },
        { icon: 'ri-lightbulb-line', text: '照明與通風改善' },
        { icon: 'ri-shower-head-line', text: '衛浴設備全面換新' },
        { icon: 'ri-storage-line', text: '空間規劃' },
      ],
      image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20bathroom%20renovation%20clean%20white%20tiles%20glass%20shower%20enclosure%20contemporary%20fixtures%20bright%20led%20lighting%20minimalist%20design%20hotel%20style%20bathroom%20elegant%20vanity%20mirror%20quality%20materials%20waterproof%20flooring%20taiwanese%20residential%20bathroom%20professional%20renovation%20work%20comfortable%20space&width=800&height=600&seq=service-detail-002&orientation=landscape',
      benefits: [
        '徹底解決漏水問題',
        '提升使用舒適度',
        '現代化設備升級',
        '增加房屋賣點',
      ],
    },
    {
      id: 'turnkey',
      title: '室內裝修統包',
      subtitle: '一站式整合服務',
      description: '設計、施工、監工一次完成，減少溝通成本。從設計規劃到完工交屋，全程由專業團隊負責，讓您省時省力又安心。',
      features: [
        { icon: 'ri-pencil-ruler-2-line', text: '專業設計規劃' },
        { icon: 'ri-team-line', text: '統包施工管理' },
        { icon: 'ri-eye-line', text: '品質監工控管' },
        { icon: 'ri-shopping-cart-line', text: '建材統一採購' },
        { icon: 'ri-calendar-check-line', text: '工程進度回報' },
        { icon: 'ri-customer-service-line', text: '單一窗口服務' },
      ],
      image: 'https://readdy.ai/api/search-image?query=complete%20interior%20renovation%20turnkey%20project%20professional%20contractors%20team%20working%20modern%20residential%20space%20organized%20construction%20site%20quality%20building%20materials%20systematic%20workflow%20taiwanese%20home%20renovation%20comprehensive%20service%20efficient%20project%20management%20clean%20work%20environment%20attention%20to%20detail&width=800&height=600&seq=service-detail-003&orientation=landscape',
      benefits: [
        '單一窗口溝通',
        '整合成本優勢',
        '縮短施工時間',
        '品質統一管控',
      ],
    },
    {
      id: 'soft-decoration',
      title: '居家軟裝設計',
      subtitle: '完整入住解決方案',
      description: '家具、燈具、窗簾、家飾佈置，讓裝修後直接入住。我們提供完整的軟裝搭配服務，從家具選購到擺設佈置，打造溫馨舒適的居家氛圍。',
      features: [
        { icon: 'ri-sofa-line', text: '家具選購與配置' },
        { icon: 'ri-lightbulb-flash-line', text: '燈具照明設計' },
        { icon: 'ri-window-2-line', text: '窗簾布藝搭配' },
        { icon: 'ri-plant-line', text: '裝飾品與綠植' },
        { icon: 'ri-palette-line', text: '色彩風格規劃' },
        { icon: 'ri-image-line', text: '掛畫與藝術品' },
      ],
      image: 'https://readdy.ai/api/search-image?query=home%20soft%20furnishing%20interior%20styling%20modern%20furniture%20arrangement%20cozy%20living%20room%20warm%20ambient%20lighting%20decorative%20cushions%20elegant%20curtains%20indoor%20plants%20beautiful%20accessories%20comfortable%20sofa%20coffee%20table%20minimalist%20decor%20inviting%20atmosphere%20professional%20interior%20design%20move%20in%20ready%20home%20complete%20decoration&width=800&height=600&seq=service-detail-004&orientation=landscape',
      benefits: [
        '省去採購煩惱',
        '專業搭配建議',
        '整體風格統一',
        '裝修後即可入住',
      ],
    },
    {
      id: 'rental',
      title: '出租裝修服務',
      subtitle: '為房東量身打造',
      description: '快速裝修、高CP值設計、耐用建材，為房東創造穩定租金收益。我們了解出租市場需求，提供最適合的裝修方案。',
      features: [
        { icon: 'ri-time-line', text: '快速施工交屋' },
        { icon: 'ri-money-dollar-circle-line', text: '高CP值規劃' },
        { icon: 'ri-shield-star-line', text: '耐用建材選擇' },
        { icon: 'ri-home-heart-line', text: '租客喜好分析' },
        { icon: 'ri-tools-line', text: '基礎設備配置' },
        { icon: 'ri-line-chart-line', text: '提升租金價值' },
      ],
      image: 'https://readdy.ai/api/search-image?query=rental%20apartment%20renovation%20modern%20studio%20design%20clean%20minimalist%20interior%20bright%20space%20quality%20furnishing%20durable%20materials%20cost%20effective%20design%20practical%20layout%20comfortable%20living%20room%20efficient%20kitchen%20contemporary%20bathroom%20move%20in%20ready%20rental%20property%20attractive%20to%20tenants&width=800&height=600&seq=service-detail-005&orientation=landscape',
      benefits: [
        '快速回收成本',
        '提高出租率',
        '減少維修頻率',
        '穩定租金收益',
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <ServicesHero />
        {services.map((service, index) => (
          <ServiceDetail key={service.id} service={service} index={index} />
        ))}
      </main>
      <Footer />
    </div>
  );
}